export default __webpack_public_path__ + "static/media/icon-eye-off.f74a0ea2.svg";